module.exports = __webpack_public_path__ + "img/ICON_CANADA.0030f254.png";